import { render, staticRenderFns } from "./RecommandedProgramsList.vue?vue&type=template&id=38aaa20b&scoped=true&"
import script from "./RecommandedProgramsList.vue?vue&type=script&lang=js&"
export * from "./RecommandedProgramsList.vue?vue&type=script&lang=js&"
import style0 from "./RecommandedProgramsList.vue?vue&type=style&index=0&id=38aaa20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aaa20b",
  null
  
)

export default component.exports